<div>
    <app-header-galleries (onSearch)="query = $event"></app-header-galleries>
    <!--<app-header [title]="'My galleries'" ></app-header>-->
    <app-galleries [query]="query"></app-galleries>
</div>